import BudgetsPages from "../../../../components/budgetsForm/pages";

const Budgets = (props: any) => {
    return <BudgetsPages {...props} persona="dealership" />;
};

export default Budgets;